import Expense from "../models/finance/Expense";
import ExpenseRequest from "../models/request/ExpenseRequest";
import {
  CATEGORY_ID_FILTER_PARAM,
  END_DATE_QUERY_PARAM,
  EXPENSES_URL,
  START_DATE_QUERY_PARAM,
} from "../utils/constants/ApiConstants";
import { formatBackendDate } from "../utils/DateUtil";
import { httpClient } from "./http/httpClient";
import { ExpenseArraySchema, ExpenseSchema, validate } from "./schemas";

export async function getExpenses(categoryId?: string): Promise<Expense[]> {
  const query = categoryId ? { [CATEGORY_ID_FILTER_PARAM]: categoryId } : undefined;
  const { data } = await httpClient.get<Expense[]>(EXPENSES_URL, { query, authenticated: true });
  return validate(ExpenseArraySchema, data);
}

export async function getExpensesInRange(startDate: Date, endDate: Date): Promise<Expense[]> {
  const query = {
    [START_DATE_QUERY_PARAM]: formatBackendDate(startDate),
    [END_DATE_QUERY_PARAM]: formatBackendDate(endDate),
  };
  const { data } = await httpClient.get<Expense[]>(EXPENSES_URL, { query, authenticated: true });
  return validate(ExpenseArraySchema, data);
}

export async function deleteExpenseById(id: string): Promise<void> {
  const url = `${EXPENSES_URL}/${id}`;
  await httpClient.delete<void>(url, { authenticated: true });
}

export async function createExpense(
  date: Date,
  amount: number,
  description: string,
  categoryTitle: string
): Promise<Expense> {
  const payload: ExpenseRequest = {
    date: formatBackendDate(date),
    amount,
    description,
    category: categoryTitle,
  };
  const { data } = await httpClient.post<Expense[], ExpenseRequest[]>(EXPENSES_URL, [payload], { authenticated: true });
  // API returns array, but we only created one, so return the first item
  return validate(ExpenseSchema, data[0]);
}

export async function updateExpense(
  id: string,
  date: Date,
  amount: number,
  description: string,
  categoryTitle: string
): Promise<Expense> {
  const url = `${EXPENSES_URL}/${id}`;
  const payload: ExpenseRequest = {
    date: formatBackendDate(date),
    amount,
    description,
    category: categoryTitle,
  };
  const { data } = await httpClient.put<Expense, ExpenseRequest>(url, payload, { authenticated: true });
  return validate(ExpenseSchema, data);
}


